module.exports = __webpack_public_path__ + "static/media/quiz.9f4a77ab.svg";